import {ROUTES} from '@/config/routesConstants';
import type {ContentSubmission} from '@/types/contentSubmission';
import {isOffPlatformPath} from './offPlatformShareToken';

function buildOffPlatformShareUrl(
  campaignId: string,
  contentSubmission?: ContentSubmission,
  shareToken?: string | null
): string {
  let path = `${ROUTES.OFF_PLATFORM_REVIEW}/${campaignId}`;

  if (contentSubmission) {
    const isMixedMedia = contentSubmission.kind === 'mixed_media';
    path = isMixedMedia
      ? `${path}/mixed-media/${contentSubmission.id}`
      : `${path}/${contentSubmission.id}`;
  }

  const currentParams = new URLSearchParams(window.location.search);
  const shareParams = new URLSearchParams();
  const brandId = currentParams.get('brandId');
  const versionId = currentParams.get('versionId');
  if (brandId) shareParams.set('brandId', brandId);
  if (versionId) shareParams.set('versionId', versionId);
  // Off-platform reviewers re-sharing have no campaign token in the payload —
  // fall back to the token already in the current URL. Gated to off-platform
  // pages so a stale URL token never beats the fresh payload token elsewhere.
  const locationToken = isOffPlatformPath(window.location.pathname)
    ? currentParams.get('token')
    : null;
  const token = shareToken || locationToken;
  if (token) {
    shareParams.set('token', token);
  }
  const search = shareParams.toString();

  return `${window.location.origin}${path}${search ? `?${search}` : ''}`;
}

export default buildOffPlatformShareUrl;
